import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useStoredAuth } from "@/hooks/useStoredAuth";
import Home from "@/pages/Home";
import BlogPage from "@/pages/BlogPage";
import Landing from "@/pages/Landing";
import NotFound from "@/pages/not-found";
import PaperPage from "./pages/PaperPage";

function Router() {
  const { isAuthenticated, isLoading } = useStoredAuth();

  return (
    <Switch>
      {isLoading || !isAuthenticated ? (
        <Route path="/" component={Landing} />
      ) : (
        <>
          <Route path="/" component={Home} />    
        </>
      )}
      <Route path="/blog" component={BlogPage} />
      <Route path="/papers" component={PaperPage} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Router />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
